import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import Rating from '@material-ui/lab/Rating';

// STYLES
import { Button } from '../styles';
import { AppCardContainer } from './styles';

const AppCardSkeleton = ({ type, ...props }) => {
  let content = null;

  switch (type) {
    case 'new-card':
      content = (
        <div {...props} className="app-card-skeleton">
          <Skeleton width="100%" height={369} variant="rect" />
        </div>
      );
      break;

    case 'service':
      content = (
        <div {...props} className="app-card-skeleton">
          <Skeleton width="100%" height={189} variant="rect" />
        </div>
      );
      break;

    default:
      content = (
        <AppCardContainer className="app-card-skeleton">
          <Skeleton className="m-b-20" variant="circle" width={70} height={70} />
          <Skeleton width={116} height={23} />
          <Skeleton className="m-b-30" width={75} height={23} />
          <Rating className="m-b-30" readOnly />
          <Skeleton width={185} height={23} />
          <Skeleton width={145} height={23} />
          <Skeleton className="m-b-15" width={105} height={23} />
          <Button className="m-b-10" />
        </AppCardContainer>
      );
      break;
  }

  return content;
};

AppCardSkeleton.defaultProps = {
  type: '',
};

AppCardSkeleton.propTypes = {
  type: PropTypes.string,
};

export default React.memo(AppCardSkeleton);
